import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ArrowRight } from "lucide-react";
import { gbp } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function CartPage() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();
  const delivery = subtotal >= 50 || subtotal === 0 ? 0 : 3.99;

  if (items.length === 0)
    return (
      <div className="container-furn py-24 text-center">
        <h1 className="font-display text-4xl font-bold uppercase">Your basket is empty</h1>
        <p className="mt-3 text-muted-foreground">Looks like you haven't added any tackle yet.</p>
        <Link to="/shop" className="mt-6 inline-block bg-accent px-8 py-4 text-xs font-bold uppercase tracking-widest text-accent-foreground">Start shopping</Link>
      </div>
    );

  return (
    <div className="container-furn py-12">
      <h1 className="mb-8 font-display text-4xl font-bold uppercase tracking-tight">Your Basket</h1>
      <div className="grid gap-10 lg:grid-cols-[1fr_360px]">
        <div className="divide-y divide-border border-y border-border">
          {items.map((i) => (
            <div key={i.product_id} className="flex gap-4 py-5">
              <Link to={i.path || `/product/${i.slug}`} className="h-28 w-28 shrink-0 overflow-hidden bg-secondary"><img src={i.image} alt={i.name} className="h-full w-full object-cover" /></Link>
              <div className="flex flex-1 flex-col">
                <span className="overline">{i.brand}</span>
                <Link to={i.path || `/product/${i.slug}`} className="font-display text-lg font-medium hover:text-accent transition-colors">{i.name}</Link>
                <div className="mt-auto flex items-center justify-between pt-3">
                  <div className="flex items-center border border-border">
                    <button onClick={() => updateQty(i.product_id, i.quantity - 1)} className="grid h-9 w-9 place-items-center hover:text-accent"><Minus className="h-3.5 w-3.5" /></button>
                    <span className="w-9 text-center text-sm">{i.quantity}</span>
                    <button onClick={() => updateQty(i.product_id, i.quantity + 1)} className="grid h-9 w-9 place-items-center hover:text-accent"><Plus className="h-3.5 w-3.5" /></button>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="font-display text-lg font-semibold">{gbp(i.price * i.quantity)}</span>
                    <button onClick={() => removeItem(i.product_id)} className="text-muted-foreground hover:text-destructive transition-colors"><Trash2 className="h-4 w-4" /></button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <aside className="h-fit border border-border bg-card p-6">
          <h3 className="mb-5 font-display text-xl font-semibold uppercase">Order Summary</h3>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Subtotal</span><span>{gbp(subtotal)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Delivery</span><span>{delivery === 0 ? "FREE" : gbp(delivery)}</span></div>
            <div className="flex justify-between border-t border-border pt-3 font-display text-lg font-bold"><span>Total</span><span>{gbp(subtotal + delivery)}</span></div>
          </div>
          <button data-testid="cart-checkout" onClick={() => navigate("/checkout")} className="mt-6 flex w-full items-center justify-center gap-2 bg-accent py-4 text-xs font-bold uppercase tracking-widest text-accent-foreground hover:brightness-110 transition-[filter]">Proceed to Checkout <ArrowRight className="h-4 w-4" /></button>
          <Link to="/shop" className="mt-3 block text-center text-xs font-bold uppercase tracking-widest text-muted-foreground hover:text-accent">Continue shopping</Link>
        </aside>
      </div>
    </div>
  );
}
